import { AnyAction, Dispatch, MiddlewareAPI, Action } from 'redux'

import { storeEvents, trackCustomEvent } from '@cinch/oxd-utils/analytics/src'
import { storeEvents as dataLayerEvents } from '@cinch/oxd-utils/analytics/src/data-layer/index'

export default (store: MiddlewareAPI<Dispatch<AnyAction>>) => (next: Dispatch<AnyAction>) => <A extends Action>(
  action: A,
) => {
  const customEvent = storeEvents[action.type]
  const customDataLayerEvent = dataLayerEvents[action.type]

  next(action)

  if (customDataLayerEvent) {
    customDataLayerEvent(action)
  }

  if (customEvent) {
    const event = customEvent(store, action)
    trackCustomEvent(event)
  }

  return
}
